import $ from 'jquery';

Foundation.Abide.defaults.patterns['proper_name_myaccount'] = /^\D*$/;

var contactInfoShopper = 
{
    initContactInfoShopper: function()
    {
        // Listen to click event on the submit button
        $('#submitForm').click(function (e)
        {
            e.preventDefault();
            window.showPreLoader();
            $("#failMsg").addClass("hide");
            $("#successMsg").addClass("hide");

            triggerFieldValidation('#states','#statesErrorMsg');
            triggerFieldValidation('#zip','#zipErrorMsg');

            if($(".is-invalid-input").length == 0)
            {
                var obj = new Object();

                obj.FirstName = $('#shopperFirstName').val();
                obj.LastName = $('#shopperLastName').val();
                obj.Address1 = $('#shopperAddress').val();
                obj.City = $('#shopperCity').val();
                obj.State = $('#states').val();
                obj.PostalCode = $('#zip').val();

                // Phone validation
                obj.HomePhone = $('#home-phone').val();
                obj.MobilePhone = $('#mobile-phone').val();
                obj.WorkPhone = $('#work-phone').val();
                obj.RecieveTextMsg = $('#cbxIsReceiveSMS').is(':checked');

                var IsPhoneAndCheckboxValid = ((obj.RecieveTextMsg && obj.MobilePhone !== "") || !obj.RecieveTextMsg);
                if(!IsPhoneAndCheckboxValid)
                {
                    $("#mobilePhoneErrorMsg").show();
                }else{$("#mobilePhoneErrorMsg").hide();}
                // GA tags
                obj.ClientId = $('#gaclientid_il').val();
                obj.UserId = $('#gauserid_il').val();
                obj.TrackId = $('#gatrackid_il').val();
                obj.LastWebCampaign = $('#galastwebcampaign_il').val();
                obj.LastWebMedium = $('#galastwebmedium_il').val();
                obj.LastWebSource = $('#galastwebsource_il').val();
                obj.WebCampaignStack = $('#gawebcampaignstack_il').val();
                obj.WebLeadId = $('#gawebleadid_il').val();

                // If the validation passes, send the ajax call
                if (obj.FirstName !== "" && obj.LastName !== "" && obj.Address !== "" && obj.City !== "" && obj.State !== "" && obj.Zip !== ""
                    && IsPhoneAndCheckboxValid) {
                    const dataJSON = JSON.stringify(obj);
                    $.ajax({
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        method: "POST",
                        url: "/myaccount/postdata",
                        data: dataJSON,
                        success: function (response) {
                            // On Success reveal the success msg
                            if (response.Success) {
                                $("#successMsg").removeClass("hide");
                            } else {
                                $("#failMsg").removeClass("hide");
                            }
                        },
                        error: function (response) {
                            if (response.status && response.status == 401) {
                                // User MSH session may have timed out. Redirect them
                                // to the signin page.
                                window.location.reload();
                            } else {
                                $("#failMsg").removeClass("hide");
                            }
                        },
                        complete: function()
                        {
                            window.hidePreLoader();
                        }
                    });
                } else 
                {
                    $("#successMsg").addClass("hide");
                    window.hidePreLoader();
                }
            }else{window.hidePreLoader();}
        });
    }   
};

function triggerFieldValidation(idInput,idErrorMsg)
{
    if(!$(idInput)[0].validity.valid)
    {
        $(idErrorMsg).addClass('is-visible');
        $(idInput).addClass('is-invalid-input'); 
    }else{
        $(idErrorMsg).removeClass('is-visible');
        $(idInput).removeClass('is-invalid-input'); 
    }
}

$(function(){
    // Attach listener on lot dropdown
    let shopperForm = $("#shopper-account-form");
    if( shopperForm && shopperForm.length > 0 ) {
        contactInfoShopper.initContactInfoShopper();
    }
});

export default contactInfoShopper;